module.exports = __webpack_public_path__ + "vfn-assets/img/team-upgrade-membresía.0645e7ff.png";